import { ExpandMoreOutlined } from '@mui/icons-material';
import { Accordion, AccordionSummary, Typography, AccordionDetails, Box, Divider, LinearProgress, useTheme } from '@mui/material';
import { IOrganization, OrganizationServices } from '../../../services/api/organization/OrganizationServices';
import { useEffect, useState } from 'react';

interface UndertakingConsolidatedProps {
    uuid: string
}

export const UndertakingConsolidated = ({uuid}: UndertakingConsolidatedProps) => {

    const [ data, setData ] = useState<IOrganization>();
    const theme = useTheme();

    useEffect(() => {
        fecthData();
    }, [uuid]);

    const fecthData = () => {
        OrganizationServices.getById(uuid)
            .then(response => {
                if(response instanceof Error){
                    console.log(response.message);
                }else{
                    setData(response);
                }
            });
    };

    if(data == undefined){
        return(
            <LinearProgress/>
        );
    }

    return(
        <Accordion
            variant='outlined'
            square={true}  sx={{borderRadius: '30px', '&:before': {display: 'none',}}} disableGutters
        >
            <AccordionSummary
                expandIcon={<ExpandMoreOutlined sx={{color: theme.palette.primary.contrastText}}/>}
            >
                <Typography><strong>Dados do empreendimento</strong></Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                    <Typography>Razão social:</Typography>
                    <Typography>{data?.razao_social}</Typography>
                </Box>
                <Divider/>
                <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                    <Typography>Unidade operacional:</Typography>
                    <Typography>{data.unidade_operacional}</Typography>
                </Box>
                <Divider/>
                <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                    <Typography>CNPJ:</Typography>
                    <Typography>{data.registro}</Typography>
                </Box>
                <Divider/>
                <Box flex={1} flexDirection={'column'} display={'flex'} gap={1}>
                    <Box display={'flex'} flexDirection={'row'} gap={1}>
                        <Typography>Rua:</Typography>
                        <Typography>{data.rua}</Typography>
                    </Box>
                    <Box display={'flex'} flexDirection={'row'} gap={1}>
                        <Typography>Número:</Typography>
                        <Typography>{data.numero}</Typography>
                    </Box>
                    <Box display={'flex'} flexDirection={'row'} gap={1}>
                        <Typography>Bairro:</Typography>
                        <Typography>{data.bairro}</Typography>
                    </Box>
                    <Box display={'flex'} flexDirection={'row'} gap={1}>
                        <Typography>Cidade:</Typography>
                        <Typography>{data.cidade}</Typography>
                    </Box>
                    <Box display={'flex'} flexDirection={'row'} gap={1}>
                        <Typography>Estado:</Typography>
                        <Typography>{data.estado}</Typography>
                    </Box>
                    <Box display={'flex'} flexDirection={'row'} gap={1}>
                        <Typography>CEP:</Typography>
                        <Typography>{data.cep}</Typography>
                    </Box>
                    <Box display={'flex'} flexDirection={'row'} gap={1}>
                        <Typography>País:</Typography>
                        <Typography>{data.pais}</Typography>
                    </Box>
                </Box>
                <Divider/>
                <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                    <Typography>Atividade principal:</Typography>
                    <Typography>{data.atividade_principal}</Typography>
                </Box>
                <Divider/>
                <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                    <Typography>Produto:</Typography>
                    <Typography>{data.produto}</Typography>
                </Box>
                <Divider/>
                <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                    <Typography>Telefone:</Typography>
                    <Typography>{data.telefone_geral}</Typography>
                </Box>
                <Divider/>
                <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                    <Typography>E-mail:</Typography>
                    <Typography>{data.email_geral}</Typography>
                </Box>
                <Divider/>
                <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                    <Typography>Responsável legal:</Typography>
                    {/* <Typography>{data.}</Typography> */}
                </Box>
                <Divider/>
            </AccordionDetails>
                            </Accordion>
    );
};